<template>
  <v-card
    max-width="1100"
    class="mx-auto"
    color="white"
    :loading="loading"
    :disabled="loading"
  >
    <v-toolbar color="primary">
      <v-toolbar-title>
        <h1>
          {{ $t("export.title") }}
        </h1>
      </v-toolbar-title>
    </v-toolbar>
    <v-card-text>
      <h2 class="pb-2">
        {{ $t("export.sub_title") }}
      </h2>
      <v-row>
        <v-col cols="12" md="4">
          <h3>
            {{ $t("export.level") }}
          </h3>
          <v-autocomplete
            variant="outlined"
            density="compact"
            v-model="level_id"
            v-bind:items="levels"
            v-bind:item-value="(item) => item.LEVEL_ID"
            v-bind:item-title="(item) => objectTranslator(item, 'LEVEL_NAME')"
            @update:modelValue="update_level"
          >
          </v-autocomplete>
        </v-col>
        <v-col cols="12" md="4">
          <h3>{{ $t("export.semester") }}/{{ $t("export.year") }}</h3>
          <v-autocomplete
            variant="outlined"
            density="compact"
            v-model="year_id"
            v-bind:items="years"
            v-bind:item-value="(item) => item.YEAR_ID"
            v-bind:item-title="
              (item) => item.ADMIT_SEMESTER + '/' + item.ADMIT_YEAR
            "
            :disabled="!level_id"
            @update:modelValue="update_year"
          >
          </v-autocomplete>
        </v-col>
        <v-col cols="12" md="4">
          <h3>รูปแบบการนำเข้านักศึกษา</h3>
          <v-autocomplete
            variant="outlined"
            density="compact"
            v-model="mode_id"
            v-bind:items="modes"
            v-bind:item-value="(item) => item.mode_id"
            v-bind:item-title="
              (item) =>
                inlineTranslator({
                  en: item.mode_name_en,
                  th: item.mode_name_th,
                })
            "
            :disabled="!year_id"
            @update:modelValue="update_mode"
          >
          </v-autocomplete>
        </v-col>
      </v-row>
      <v-row v-if="mode_id === 'each'">
        <v-col cols="12" md="4">
          <h3>
            {{ $t("export.student_id") }}
          </h3>
          <v-text-field
            v-model="student_id"
            density="compact"
            variant="outlined"
            append-inner-icon="mdi-magnify"
          >
          </v-text-field>
        </v-col>
        <v-col class="my-auto">
          <v-btn
            variant="outlined"
            color="primary"
            :disabled="!student_id"
            @click="get_register_info()"
          >
            {{ $t("export.search") }}
          </v-btn>
        </v-col>
        <v-col cols="12" md="4" v-if="name">
          <h3>
            {{ $t("export.name") }} {{ name }} {{ $t("export.surname") }}
            {{ surname }}
          </h3>
        </v-col>
      </v-row>
      <v-row v-if="mode_id">
        <v-col cols="12" class="my-auto">
          <v-btn color="primary" @click="create_student_to_kmitl1()">
            {{ $t("export.add_student") }}
          </v-btn>
          <v-btn
            class="ml-2"
            variant="outlined"
            color="primary"
            @click="clear()"
          >
            {{ $t("export.reset") }}
          </v-btn>
        </v-col>
      </v-row>
    </v-card-text>
    <v-divider> </v-divider>
  </v-card>
</template>

<script>
import { inlineTranslator, objectTranslator } from "@/helper/translator";
import ConfigProvider from "@/services/config.provider";
import DataSyncProvider from "@/services/data.sync.provider";
import { listFilter, getById } from "@/helper/filter";

const configProvider = new ConfigProvider();
const dataSyncProvider = new DataSyncProvider();

export default {
  name: "ExportData",
  data: () => ({
    loading: false,
    level_id: null,
    year_id: null,
    mode_id: null,
    years: [],
    student_id: null,
    year: null,
    semester: null,
    modes: [
      {
        mode_id: "each",
        mode_name_en: "1. นำเข้ารายบุคคลด้วยรหัสนักศึกษา",
        mode_name_th: "1. นำเข้ารายบุคคลด้วยรหัสนักศึกษา",
      },
      {
        mode_id: "all",
        mode_name_en: "2. นำเข้าทั้งหมด",
        mode_name_th: "2. นำเข้าทั้งหมด",
      },
    ],
    name: null,
    surname: null,
  }),

  methods: {
    objectTranslator,
    inlineTranslator,
    listFilter,
    getById,

    async update_level(level_id) {
      this.year_id = null;
      this.mode_id = null;
      this.student_id = null;
      const years = await configProvider.getYearByLevelIds(level_id);
      this.years = years;
    },

    async update_year() {
      this.mode_id = null;
      this.student_id = null;
      const ref_data_year_semester = getById(
        this.years,
        this.year_id,
        "YEAR_ID"
      );
      this.year = ref_data_year_semester.ADMIT_YEAR;
      this.semester = ref_data_year_semester.ADMIT_SEMESTER;
    },

    update_mode() {
      this.student_id = null;
      this.name = null;
      this.surname = null;
    },

    async get_register_info() {
      const register_info =
        await dataSyncProvider.getRegistrarStudentInfoByStudentID(
          this.student_id
        );
      this.name = register_info.STUDENT_FNAME_TH;
      this.surname = register_info.STUDENT_LNAME_TH;
    },

    async create_student_to_kmitl1() {
      this.loading = true;
      const response = await dataSyncProvider
        .createStudentsToRegistrar({
          LEVEL_ID: this.level_id,
          ADMIT_YEAR: this.year,
          ADMIT_TERM: this.semester,
          STUDENT_ID: this.mode_id == "all" ? null : this.student_id,
        })
        .catch((error) => {
          this.$toast.error(JSON.stringify(error.response.data.message));
          this.loading = false;
        });
      if (response && response.status) {
        this.$toast.success(this.$t("ย้ายสำเร็จ"));
      }
      this.loading = false;
    },

    clear() {
      this.level_id = null;
      this.update_level();
    },
  },

  computed: {
    levels() {
      return this.$store.state.ref.levels;
    },
  },
  created() {
    this.$store.dispatch("ref/getLevels");
  },
};
</script>

<style scoped></style>
